import { render, staticRenderFns } from "./SpeechTransition.vue?vue&type=template&id=8e814a8a&"
import script from "./SpeechTransition.vue?vue&type=script&lang=js&"
export * from "./SpeechTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports